import { assessmentRoutes } from "./routes";

import { AppRouter } from "../shared/components/AppRouter";

export const AssessmentRoutes = () => <AppRouter routes={assessmentRoutes} />;
